import {Component, Input, OnInit} from '@angular/core';
import { ShipmentProductLine } from "../services/shipment-product-line";

@Component({
  selector: 'app-dg-badges',
  templateUrl: './dg-badges.component.html',
  styleUrls: ['./dg-badges.component.scss']
})
export class DgBadgesComponent implements OnInit {
    @Input() productLine!: ShipmentProductLine;

  constructor() { }

  ngOnInit(): void {
  }

}
